// extracted by mini-css-extract-plugin
module.exports = {"heading":"testimonial_heading__1NjGP","attr":"testimonial_attr__lfnT9","body":"testimonial_body__3mJJi","element":"testimonial_element__1GT7R","accent":"testimonial_accent__1UM7X"};